<mat-form-field appearance="fill" *ngIf="control">
    <mat-label *ngIf="placeholder">{{ placeholder }}</mat-label>
    <input
        [type]="type"
        matInput
        [id]="id"
        [min]="min"
        [formControl]="control"
        [autocomplete]="autocomplete"
    />
    <mat-error *ngIf="control.hasError('min')">
        {{ "ERRORS.MIN" | translate }} {{ min }}
    </mat-error>
</mat-form-field>
